import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataserviceService } from 'src/app/dataservice.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
  selector: 'app-starlink-documents',
  templateUrl: './starlink-documents.component.html',
  styleUrl: './starlink-documents.component.css'
})
export class StarlinkDocumentsComponent {

  @Input() fullData: any;
  @Output() documentsDone = new EventEmitter<{ acknowledged: boolean; nextPage: 'starlink-order' }>();

  docsForm: FormGroup;
  starlinkDisclosures: string[] = [];
  dishDisclosures: string[] = [];
  loading = false;

  constructor(private fb: FormBuilder, private h: DataserviceService, private notification: NzNotificationService) {
    this.docsForm = this.fb.group({
      acknowledged: [false, Validators.requiredTrue]
    });
  }

  ngOnInit(): void {
    this.loadDocuments();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.fullData?.documents?.acknowledged) {
      this.docsForm.patchValue({ acknowledged: this.fullData.documents.acknowledged });
    }
    if(this.fullData?.documents?.disclosures) {
      this.dishDisclosures = this.fullData.documents.disclosures;
    }
    if(this.fullData?.documents?.starlinkDisclosures) {
      this.starlinkDisclosures = this.fullData.documents.starlinkDisclosures;
    }
  }

  loadDocuments(): void {
    this.loading = true;
    // TODO: 2 API calls - GET /dishapi/starlink/disclosures and GET /dishapi/starlink/setup/installation
    // setTimeout(() => {
    //   this.starlinkDisclosures = [
    //     'Starlink Service Agreement — Placeholder. Replace with GET /dishapi/starlink/disclosures response.'
    //   ];
    //   this.dishDisclosures = [
    //     'Dish Installation Disclosures — Placeholder. Replace with GET /dishapi/starlink/setup/installation response.'
    //   ];
    //   this.loading = false;
    // }, 300);
    // this is for prod, needs testing when we get access
    this.h.getData('starlink/disclosures').subscribe(
      res => {
        const cleanText = res.data.data.disclosures[0].disclosure
          .replace(/<\/p>/gi, '\n\n')
          .replace(/<br\s*\/?>/gi, '\n')
          .replace(/<li>/gi, '\n- ')
          .replace(/<\/ul>/gi, '\n')
          .replace(/<[^>]+>/g, '')
          .replace(/&nbsp;/g, ' ')
          .replace(/&quot;/g, '"')
          .replace(/&#39;/g, "'")
          .replace(/&ldquo;/g, '"')
          .replace(/&rdquo;/g, '"')
          .replace(/\n{3,}/g, '\n\n')
          .trim();
        this.starlinkDisclosures = [cleanText];
        this.loading = false;
      },
      e => {
        this.notification.error('Error', 'Failed to load starlink disclosures');
        console.log(e);
        this.loading = false;
      }
    )
  }

  submit(): void {
    if (this.docsForm.invalid) return;

    const acknowledged = this.docsForm.value.acknowledged;
    this.documentsDone.emit({ acknowledged, nextPage: 'starlink-order' });
  }
}